import { State } from 'src/types'
import { deepWeb } from './deepWeb'
import { shallowWeb } from './shallowWeb'

export const webDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  const isShallowWebModel = ['AKG-JS2'].includes(state.baseModel.productNumber)
  if (isShallowWebModel) {
    shallowWeb(ctx, state) // 浅めのウェブ
  }
  if (!isShallowWebModel) {
    deepWeb(ctx, state) // 普通・深めのウェブ
  }
}
